import { Injectable } from '@angular/core';

import { BetBuilderProvider } from '@cds/betting-offer/add-ons';
import { BetBuilderInfo } from '@frontend/sports/betting-offer/feature/model';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';
import { NOT_APPLICABLE } from '@frontend/sports/tracking/feature';

import { BetBuilderTrackingValues } from '../bet-builder/bet-builder-tracking';
import { isProviderSupportingBadges } from '../bet-builder/utils';

@Injectable({
    providedIn: 'root',
})
export class BetTrackingService {
    getBetDetails(
        hasBetBuilderMarkets: boolean,
        betBuilderInfo: BetBuilderInfo | null,
        sourceOfPick: SourceOfPick,
        betDetails: string | undefined,
    ): string {
        if (!(hasBetBuilderMarkets && isProviderSupportingBadges(betBuilderInfo))) {
            return betDetails ? betDetails : NOT_APPLICABLE;
        }

        const betBuilderProvider = betBuilderInfo?.betBuilderProvider;
        const groupId = betBuilderInfo?.betBuilderId ? `;${betBuilderInfo.betBuilderId}` : '';

        switch (sourceOfPick) {
            case SourceOfPick.EmbeddedBetBuilder:
                return (
                    (betBuilderProvider === BetBuilderProvider.Angstrom
                        ? BetBuilderTrackingValues.AngstromSgpEmbedded
                        : BetBuilderTrackingValues.InHouseFootballSgpEmbedded) + groupId
                );

            case SourceOfPick.OverlayBetBuilder:
                return (
                    (betBuilderProvider === BetBuilderProvider.Angstrom
                        ? BetBuilderTrackingValues.AngstromSgpOverlay
                        : BetBuilderTrackingValues.InHouseFootballSgpOverlay) + groupId
                );

            case SourceOfPick.EventDetails:
                return (
                    (betBuilderProvider === BetBuilderProvider.Angstrom
                        ? BetBuilderTrackingValues.AngstromSgpEventDetails
                        : BetBuilderTrackingValues.InHouseFootballSgpEventDetails) + groupId
                );

            case SourceOfPick.TopEvents:
                return (
                    (betBuilderProvider === BetBuilderProvider.Angstrom
                        ? BetBuilderTrackingValues.AngstromSgpTopEvents
                        : BetBuilderTrackingValues.InHouseFootballSgpTopEvents) + groupId
                );

            default:
                return NOT_APPLICABLE;
        }
    }
}
